export default __webpack_public_path__ + "images/Calendar.v-72dd3af30e734a4ae0f47b4f128b6888.png";